import * as React from 'react';
import { useSelector } from 'react-redux';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
// import { useLaender, useLaenderByIkz2 } from 'api/lookup';
import { laenderByIkz2Selector, laenderSelector } from 'store/lookups/selector';

interface LandByLkz2Props {
    label?: string;
    disabled: boolean;
    value: string | null;
    onChange: (newValue: string) => void;
}

export const LandByLkz2: React.FC<LandByLkz2Props> = ({ label, value, disabled, onChange }) => {
    const laender = useSelector(laenderSelector);
    const laenderByIkz2 = useSelector(laenderByIkz2Selector);

    return (
        <>
            <Label>{label || 'Land'}</Label>
            <Select
                name="land"
                isDisabled={disabled}
                value={
                    value
                        ? {
                              value: value.toString(),
                              label: laenderByIkz2[value]?.text || value,
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={laender.map((l) => ({
                    value: l.ikz2,
                    label: l.text,
                }))}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '  ');
                }}
            />
        </>
    );
};
